import React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ui } from '../../../../../../interfaces/interfaces';
import useDebugInformation from '../../../../../../hooks/useDebugInformation';
import { reducer, initialStageState, ACTIONS } from './helpers';
import Button from '@mui/material/Button';
import { getActiveStep } from '../../../../../../utilities/validation';
import { useAppSelector } from "@store/hooks";

const name = "Stage3Panel"

type Props = {
    parent: string
    prefix: string
}

const Stage3Panel: React.FC<Props> = ({ parent, prefix }) => {
    const [state, dispatch] = React.useReducer(reducer, initialStageState);
    const isBookingBillingSet = useAppSelector(({ state }) => state.Step3_3Valid)
    const bookingPaymentIsBooked = useAppSelector(({ ui }) => ui.BookingPaymentIsBooked)
    const bookingRejectionReason = useAppSelector(({ ui }) => ui.BookingRejectionReason)
    const isAQuote = useAppSelector(({ state }) => state.IsAQuote)
    const isAGoBack = useAppSelector(({ state }) => !!state?.IsAGoBack)

    const stage3Complete = useAppSelector(({ state }) => state.Step3_3Complete)
    const carePlanCompleted = useAppSelector(({ state }) => state.Step3_2Valid)
    const steps = React.useMemo(() => Object.values(state), [state])
    const [activeStep, setActiveStep] = React.useState(getActiveStep(steps))

    React.useEffect(() => {
        dispatch(ACTIONS.SET_CHARGE_RATE_STATE(prefix))
    }, [prefix])

    React.useEffect(() => {
        dispatch(ACTIONS.SET_CARE_PLAN_DETAILS(prefix, carePlanCompleted)) //CARE PLAN DETAILS STATE
    },
        [carePlanCompleted, prefix]
    )


    React.useEffect(() => {
        dispatch(ACTIONS.SET_BOOKING_STATE(prefix, isBookingBillingSet)) //BOOKING STATE
    }, [stage3Complete, isBookingBillingSet, prefix])

    React.useEffect(() => {
        ui.Stage3Complete = ((carePlanCompleted && isBookingBillingSet && bookingPaymentIsBooked) || (!bookingPaymentIsBooked && !!bookingRejectionReason) || (carePlanCompleted && (isAQuote || isAGoBack)))
    }, [state, carePlanCompleted, isBookingBillingSet, bookingPaymentIsBooked, bookingRejectionReason, isAQuote, isAGoBack])

    const debugName = `${parent}▷[${name}]`

    React.useEffect(() => {
        setActiveStep(getActiveStep(steps))
    }, [activeStep, stage3Complete, steps])

    useDebugInformation(debugName, { state, steps, stage3Complete, activeStep })

    return (
        <Box id="left-panel" sx={{ width: 260, p: 1 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    < Step key={step.label} >
                        <StepLabel
                            optional={
                                index === steps.length - 1 ? (
                                    <Typography variant="caption">Last step of this stage</Typography>
                                ) : null
                            }
                        >
                            {step.label}
                        </StepLabel>
                        <StepContent>
                            <Typography>{step.description}</Typography>
                            {index === 2 && step.description.toLowerCase().includes("fail") && <Button variant='contained' color='secondary'>FAIL</Button>}
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {
                activeStep === steps.length && (
                    <Paper square elevation={0} sx={{ p: 3 }}>
                        <Typography>All steps completed - please continue to next stage!</Typography>
                    </Paper>
                )
            }
        </Box >
    );
}

Stage3Panel.displayName = name;


export default Stage3Panel